<template lang="html">
  <div class="table-header">
  <div class="table-row row no-margin">
    <div class="table-th w200">INDENT ID</div>
    <div class="table-th w200">Delivery Mode</div>
    <div class="table-th w300">Loading Point</div>
    <div class="table-th summary-action">Total</div>
  </div>
</div>

</template>

<script>
export default {
 data() {
  return {
  };
 },
};
</script>